import styled from 'styled-components';

/**
 * Bare `<fieldset>` with browser default border/padding/margin reset.
 *
 * Use to leverage the native `disabled` attribute (which cascades to all
 * descendant form controls) without inheriting the browser's groove border
 * and spacing.
 */
export const ResetFieldset = styled.fieldset`
  border: none;
  padding: 0;
  margin: 0;
`;
